import { z } from 'zod'

const destinationSchema = z.object({
  server: z.string(),
  tag: z.string().nullish(),
  infos: z.record(z.string(), z.string())
})

const transferDestinationSchema = z.object({
  userId: z.string(),
  name: z.string()
})

const originSchema = z.object({
  destinationId: z.number(),
  companyName: z.string(),
  userName: z.string(),
  destinationDescription: z.string(),
  connectionKey: z.string(),
  destination: destinationSchema
})

export const transferChatSchema = (isTakeChat: boolean) => {
  const transferDestinations = isTakeChat ? transferDestinationSchema.nullish() : transferDestinationSchema

  return z.object({
    origin: originSchema,
    transferDestinations,
    comment: z.string()
  })
}
